export default (paths) => paths.map((path) => import(`/src/web_components/components/${path}`));
